import React from "react";
import Container from "./Container";
import Section from "./Section";
import { ProductCategoryCard } from "./ProductCategoryCard";
import { ArticleCard } from "./ArticleCard";
import Grid from "./Grid";
import { convertToRelativePath } from '../utils/convertToRelativePath';

export const ProductTypeFeed = ({
  productTypes,
  heading,
  productCardStyle,
}) => {
  return (
    productTypes &&
    productTypes.length > 0 && (
      <Section grey={!productCardStyle} heading={heading}>
        <Container>
          <Grid as="ul" equalHeight>
            {productTypes.map((item) => {
              return (
                <Grid
                  item
                  as="li"
                  sm="6"
                  md={productCardStyle ? "3" : "4"}
                  key={item.customLinkHeading}
                >
                  {item.customLink ? (
                    <>
                      {productCardStyle ? (
                        <ArticleCard
                          url={item.customLinkUrl}
                          title={item.customLinkHeading}
                          featuredImage={item.customLinkImage?.mediaItemUrl}
                          catColour
                          product="true"
                          category
                        />
                      ) : (
                        <ProductCategoryCard
                          url={convertToRelativePath(item.customLinkUrl)}
                          title={item.customLinkHeading}
                          description={item.customLinkDescription}
                          featuredImage={item.customLinkImage?.mediaItemUrl}
                        />
                      )}
                    </>
                  ) : (
                    <>
                      {productCardStyle ? (
                        <ArticleCard
                          url={item.productType.uri}
                          title={
                            item.productType.feed.title ||
                            item.productType.title
                          }
                          featuredImage={item.productType.featuredImage?.node.mediaItemUrl}
                          catColour
                          product="true"
                          category
                        />
                      ) :
                        item.productType && (
                        <ProductCategoryCard
                          url={item.productType.uri}
                          title={
                            item.productType.feed.title ||
                            item.productType.title
                          }
                          description={item.productType.feed.shortDescription}
                          featuredImage={item.productType.featuredImage?.node.mediaItemUrl}
                        />
                      )}
                    </>
                  )}
                </Grid>
              );
            })}
          </Grid>
        </Container>
      </Section>
    )
  );
};
